import { parseCSV } from "./parseCsv";
import { IProductMap } from "./IProductMap";

export class ProductMapper {
  private productMap: Map<string, IProductMap> = new Map<string, IProductMap>();
  constructor() {
  }

  async loadProductList(url: string) {
    const response = await fetch(url);
    const csvText = await response.text();
    const csvArray = parseCSV(csvText);
    let count: number = 0;
    for (const row of csvArray) {
      if (count>0){
        const id: string = row[0];
        const name: string = row[2];
        const videoName: string = row[3];
        this.productMap.set(id, {id, name, videoName});
      }
      count++;
    }
  }

  getProductMapById(id: string){
    return this.productMap.get(id);
  }

  async fetchProducts() {
    console.log('Fetching products...');
    await this.loadProductList(`../assets/csv/products.csv?random=${Math.random()}`);
    console.log('Products fetched.');
  }

}
